








































import { Component, Mixins } from 'vue-property-decorator';
import FieldMixin from '@/mixins/registration/FieldMixin';

@Component
export default class SocialAccountLogin extends Mixins(FieldMixin) {
  public socialAccountTooltip =
  {
    content: 'Save time by registering with one of your social accounts below and we will pre-fill your account information. Once you connect your social account you\'ll be redirected back to this page so you can complete your registration.',
    classes: 'v-tooltip',
    placement: 'bottom',
    container: 'body',
    trigger: 'hover click'
  };

  get loginAccountTooltip (): any {
    let content = '';

    if (this.registrationData.registrationType === 'ExhibitorRegistration') {
      content = 'If you already have an account, login using this link. Once you login you will be redirected to complete your exhibitor registration for ' + this.registrationData.event.name + '.';
    } else if (this.registrationData.registrationType === 'OrganizationMembership') {
      content = 'If you already have an account, login using this link. Once you login you will be redirected to complete your ' + this.registrationData.membership?.name + ' membership for your organization and join the ' + this.registrationData.community?.name + ' community.';
    } else {
      content = 'Login using this link to have your information pre-filled. Once you login you will be redirected back to this page so you can complete your registration.';
    }

    return {
      content: content,
      classes: 'v-tooltip',
      placement: 'bottom',
      container: 'body',
      trigger: 'hover click'
    };
  }

  get formUrl (): string {
    return this.registrationSetup.socialLoginUrl + '?communityId=' + this.registrationData.community?.id + '&returnUrl=' + window.location.pathname;
  }

  get loginUrl (): string {
    return '/account/login?returnUrl=' + window.location.pathname;
  }

  get sectionHidden (): boolean {
    return this.registrationData.accountCreationRequired && (this.registrationData.user == null || this.registrationData.user.id == null || this.registrationData.user.id === 0);
  }

  get socialHidden (): boolean {
    return this.isHidden('Social');
  }

  get loginHidden (): boolean {
    return this.isHidden('Login');
  }

  get socialHelpText (): string {
    return this.getCustomHelpText('Social') || '';
  }

  get socialLabel (): string {
    return this.getCustomLabel('Social') || 'Register with a social account';
  }

  get loginLabel (): string {
    return (this.socialHidden ? '' : ' or ') + 'Login with an existing ' + this.registrationData.community?.name + ' account';
  }
}
